<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="46px" height="38px" viewBox="0 0 46 38" enable-background="new 0 0 46 38" xml:space="preserve">
<path fill="#FFFFFF" d="M39.777,10.458l-1.245-1.459c-0.719-0.841-1.771-1.323-2.891-1.323c-0.93,0-1.836,0.336-2.548,0.946
	l-0.487,0.406c-0.473-1.455-1.823-2.517-3.432-2.517H18.42c-0.272,0-0.533,0.118-0.714,0.322l-7.47,8.5
	C10.084,15.506,10,15.729,10,15.96v12.924c0,2,1.627,3.626,3.626,3.626h15.549c1.999,0,3.626-1.627,3.626-3.626v-7.561l4.144-3.416
	l2.36-2.014c0.805-0.687,1.291-1.64,1.371-2.682C40.753,12.199,40.434,11.219,39.777,10.458z M31.862,12.165l1.363,1.595
	l-9.898,8.222l-1.365-1.598L31.862,12.165z M21.146,21.766l3.018,3.532l-4.548,0.814L21.146,21.766z M25.679,24.734l-1.365-1.597
	l9.899-8.221l1.396,1.633L25.679,24.734z M17.706,9.709v3.572c0,1.059-0.861,1.92-1.919,1.92h-2.906L17.706,9.709z M30.902,28.884
	c0,0.953-0.775,1.728-1.728,1.728H13.626c-0.953,0-1.727-0.775-1.727-1.728V16.72h3.888c1.896,0,3.438-1.543,3.438-3.439V8.41h9.949
	c0.952,0,1.728,0.776,1.728,1.729v0.311l-10.821,9.027c-0.133,0.11-0.232,0.253-0.289,0.416l-2.509,7.126
	c-0.111,0.32-0.046,0.674,0.173,0.931c0.183,0.214,0.447,0.334,0.724,0.334c0.056,0,0.111-0.005,0.167-0.015l7.458-1.335
	c0.16-0.029,0.311-0.098,0.438-0.202l4.66-3.842V28.884z M38.071,14.451l-1.305,1.114L33.02,11.18l1.308-1.116
	c0.805-0.687,2.104-0.605,2.762,0.167l1.246,1.462c0.327,0.379,0.485,0.868,0.447,1.375C38.741,13.604,38.488,14.094,38.071,14.451z
	"/>
</svg>
</template>

<script>
    export default {
        name: "SourceNotesIcon"
    }
</script>

<style scoped>

</style>